@for (bucketsGroup of facet().buckets; track bucketsGroup.value) {
  <mp-attribute-facet-buckets-group
    [bucketsGroup]="bucketsGroup"
    [selectedValues]="selectedValues()[bucketsGroup.label]"
    [icon]="icon()"
    [trackInsightsEvents]="trackInsightsEvents()"
    [insightsEventsConfig]="insightsEventsConfig()"
    [isExpanded]="isExpanded(bucketsGroup)"
    (isExpandedChange)="onIsExpandedChange($event, bucketsGroup.value)"
    [searchFieldPlaceholder]="searchFieldPlaceholder()"
    [isSearchExpanded]="isSearchExpanded(bucketsGroup.value)"
    (isSearchExpandedChange)="onIsSearchExpandedChange($event, bucketsGroup.value)"
    (selectedValuesChange)="onSelectedValuesChange($event, bucketsGroup.label)"
    (showMoreClick)="showMore(bucketsGroup.value)"
  />
}
